import { Flex, Button } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

interface IProps {
  onNext?: () => void;
  onPrevious?: () => void;
  nextLabel?: string;
  isDisabled?: boolean;
  isNextSecondary?: boolean;
  previousLabel?: string;
  complete?: boolean;
}

const PrevNextButtons = (props: IProps) => {
  const { onNext, onPrevious, nextLabel = 'Next', previousLabel = 'Previous', isDisabled = false } = props;

  return (
    <Flex gap={{ base: 2, lg: 4 }}>
      {onPrevious && !isDisabled && (
        <Button
          onClick={onPrevious}
          leftIcon={<FontAwesomeIcon icon={faChevronLeft} className="utility-icon" />}
          size="lg"
          flexBasis="100%"
          flexGrow="1"
          flexShrink="1"
        >
          {previousLabel}
        </Button>
      )}
      {onNext && !isDisabled && (
        <Button
          onClick={onNext}
          size="lg"
          flexBasis="100%"
          flexGrow="1"
          flexShrink="1"
          name="_action"
          rightIcon={<FontAwesomeIcon icon={faChevronRight} className="utility-icon" />}
        >
          {nextLabel}
        </Button>
      )}
    </Flex>
  );
};

export { PrevNextButtons };
